import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../env";
import "../Assets/scss/particularData.scss";

const Particulardata = () => {
	const { id } = useParams();
	const [studentslist, setStudentslist] = useState([]);
	const [totalanswers, settotalanswers] = useState([]);
	const [quizResult, setquizResult] = useState([]);
	const [hybridResult, sethybridResult] = useState([]);
	const [codingResult, setcodingResult] = useState([]);

	function findScore(scorearrayquiz, scorearraycoding) {
		let score = 0;
		for (let i = 0; i < scorearrayquiz.length; i++) {
			score += scorearrayquiz[i].score;
		}
		let codingscore = 0;
		for (let i = 0; i < scorearraycoding.length; i++) {
			codingscore += scorearraycoding[i].score;
		}
		return codingscore + score;
	}

	useEffect(() => {
		fetch(BASE_URL + "/getalltheresultsofassignmentsbycourseids/" + id, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				settotalanswers(data.totalanswers);
			});

		fetch(BASE_URL + "/getallthestudentsinaparticularcourse/" + id, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				setStudentslist(data.studentsenrolledincourses);
			});
	}, []);

	useEffect(() => {
		var hybridexamids = totalanswers?.hybridanswer?.exams?.map((value) => {
			return {
				examid: value._id,
				nameoftheExam: value.nameoftheExam,
				typeOfExam: value.typeOfExam,
			};
		});

		var hybridexamsresults = totalanswers?.hybridanswer?.results;

		// console.log("hybridexamids", hybridexamids);
		var hybridexamsandresults = hybridexamids?.map(function (item) {
			let allhybridresults = hybridexamsresults.filter(
				(value) => value.examID === item.examid
			);

			function GetAllUniqueResultsaccordingtoEmail(allhybridresults) {
				var uniqueResults = [];
				var uniqueEmails = [];
				allhybridresults.forEach(function (item) {
					if (uniqueEmails.indexOf(item.email) === -1) {
						uniqueEmails.push(item.email);
						uniqueResults.push(item);
					}
				});
				return uniqueResults;
			}

			let uniqueallhybridresults =
				GetAllUniqueResultsaccordingtoEmail(allhybridresults);

			return {
				examid: item.examid,
				results: uniqueallhybridresults,
				submitdate: item.nameoftheExam,
				typeOfExam: item.typeOfExam,
			};
		});

		var codingexamsids = totalanswers?.codinganswers?.exams?.map(
			(value) => {
				return {
					examid: value._id,
					name: value.name,
					typeOfExam: value.typeOfExam,
				};
			}
		);

		var codingexamsresults = totalanswers?.codinganswers?.results;

		var codingexamsandresults = codingexamsids?.map(function (item) {
			let allcodingresults = codingexamsresults.filter(
				(value) => value.examId === item.examid
			);

			function GetAllUniqueResultsaccordingtoEmail(allcodingresults) {
				var uniqueResults = [];
				var uniqueEmails = [];
				allcodingresults.forEach(function (item) {
					if (uniqueEmails.indexOf(item.email) === -1) {
						uniqueEmails.push(item.email);
						uniqueResults.push(item);
					}
				});
				return uniqueResults;
			}

			let uniqueallcodingresults =
				GetAllUniqueResultsaccordingtoEmail(allcodingresults);

			return {
				examid: item.examid,
				results: uniqueallcodingresults,
				name: item.name,
				typeOfExam: item.typeOfExam,
			};
		});

		var quizexamsids = totalanswers?.quizanswers?.exams?.map((value) => {
			return {
				examid: value._id,
				examName: value.examName,
				typeOfExam: value.typeOfExam,
			};
		});

		var quizexamsresults = totalanswers?.quizanswers?.results;

		// console.log("quizexamsids", quizexamsids);
		var quizexamsandresults = quizexamsids?.map(function (item) {
			let allquizresults = quizexamsresults.filter(
				(value) => value.examId === item.examid
			);

			function GetAllUniqueResultsaccordingtoEmail(allquizresults) {
				var uniqueResults = [];
				var uniqueEmails = [];
				allquizresults.forEach(function (item) {
					if (uniqueEmails.indexOf(item.email) === -1) {
						uniqueEmails.push(item.email);
						uniqueResults.push(item);
					}
				});
				return uniqueResults;
			}

			let uniqueallquizresults =
				GetAllUniqueResultsaccordingtoEmail(allquizresults);

			return {
				examid: item.examid,
				results: uniqueallquizresults,
				examName: item.examName,
				typeOfExam: item.typeOfExam,
			};
		});
		setquizResult(quizexamsandresults);
		setcodingResult(codingexamsandresults);
		sethybridResult(hybridexamsandresults);
		console.log("hybridexamsandresults", hybridexamsandresults);
		console.log("codingexamsandresults", codingexamsandresults);
		console.log("quizexamsandresults", quizexamsandresults);
		// console.log(hybridexamsandresults);
	}, [totalanswers]);

	function ResultExistsorNot(results, email) {
		let result = results.filter((value) => value.email === email);
		if (result.length > 0) {
			return true;
		} else {
			return false;
		}
	}
	function CalculateCodingScore(scoreArray) {
		let score = 0;
		for (let i = 0; i < scoreArray.length; i++) {
			score += scoreArray[i].score;
		}
		return score;
	}

	function tableToCSV() {
		// Variable to store the final csv data
		var csv_data = [];
		// Get each row data
		var rows = document.getElementsByTagName("tr");
		for (var i = 0; i < rows.length; i++) {
			// Get each column data
			var cols = rows[i].querySelectorAll("td,th");
			// Stores each csv row data
			var csvrow = [];
			for (var j = 0; j < cols.length; j++) {
				// Get the text data of each cell
				// of a row and push it to csvrow
				csvrow.push(cols[j].innerHTML);
			}
			// Combine each column value with comma
			csv_data.push(csvrow.join(","));
		}
		// Combine each row data with new line character
		csv_data = csv_data.join("\n");
		// Call this function to download csv file
		downloadCSVFile(csv_data);
	}

	function downloadCSVFile(csv_data) {
		// Create CSV file object and feed
		// our csv_data into it
		let CSVFile = new Blob([csv_data], {
			type: "text/csv",
		});
		// Create to temporary link to initiate
		// download process
		var temp_link = document.createElement("a");
		// Download csv file
		temp_link.download = "ParticularData.csv";
		var url = window.URL.createObjectURL(CSVFile);
		temp_link.href = url;
		// This link should not be displayed
		temp_link.style.display = "none";
		document.body.appendChild(temp_link);
		// Automatically click the link to
		// trigger download
		temp_link.click();
		document.body.removeChild(temp_link);
	}

	return (
		<>
			<div className="particularData">
				<table className="table table-bordered table-hover particularDataTable">
					<thead>
						<tr>
							<th>S no.</th>
							<th>Email</th>
							{quizResult?.map((val, index) => {
								return <th key={index}>{val?.examName}</th>;
							})}
							{hybridResult?.map((val, index) => {
								return <th key={index}>{val?.submitdate}</th>;
							})}
							{codingResult?.map((val, index) => {
								return <th key={index}>{val?.name}</th>;
							})}
						</tr>
					</thead>
					<tbody>
						{studentslist?.map((val, index) => {
							return (
								<tr key={index}>
									<td>{index + 1}</td>
									<td>{val?.user?.email}</td>
									{quizResult?.map((value, index) => {
										if (
											ResultExistsorNot(
												value?.results,
												val?.user?.email
											)
										) {
											return (
												<>
													{value?.results.map(
														(item, index) => {
															return (
																<>
																	{val?.user
																		?.email ===
																	item?.email ? (
																		value?.examid ===
																		item?.examId ? (
																			<td>
																				{
																					item?.finalScore
																				}
																			</td>
																		) : (
																			<>
																				{" "}
																			</>
																		)
																	) : null}
																</>
															);
														}
													)}
												</>
											);
										} else {
											return <td>-</td>;
										}
									})}
									{hybridResult?.map((value, index) => {
										if (
											ResultExistsorNot(
												value?.results,
												val?.user?.email
											)
										) {
											return (
												<>
													{value?.results.map(
														(item, index) => {
															return (
																<>
																	{val?.user
																		?.email ==
																		item
																			?.quizresults
																			?.email &&
																	value?.examid ==
																		item
																			?.quizresults
																			?.examId ? (
																		<td>
																			{findScore(
																				item
																					?.quizresults
																					?.score,
																				item
																					?.coderesults
																					?.scoring
																			)}
																		</td>
																	) : null}
																</>
															);
														}
													)}
												</>
											);
										} else {
											return <td>-</td>;
										}
									})}
									{codingResult?.map((value, index) => {
										if (
											ResultExistsorNot(
												value?.results,
												val?.user?.email
											)
										) {
											return (
												<>
													{value?.results.map(
														(item, index) => {
															return (
																<>
																	{val?.user
																		?.email ==
																		item?.email &&
																	value?.examid ==
																		item?.examId ? (
																		<td>
																			{CalculateCodingScore(
																				item?.scoring
																			)}
																		</td>
																	) : null}
																</>
															);
														}
													)}
												</>
											);
										} else {
											return <td>-</td>;
										}
									})}
								</tr>
							);
						})}
					</tbody>
				</table>
				<div className="particularDataDwnldBtn" onClick={tableToCSV}>
					<i class="fas fa-file-download"></i>
				</div>
			</div>
		</>
	);
};

export default Particulardata;
